// [uTheory](http://utheory.com) - Copyright (c) Gregory Ristow 2018
//
// ### completeMeasureQuestion
// ## Question generator for CompleteTheMeasure interactives
//
// Include description of object & useful info here, please!
import type Music from '../uTheory.Notation/music';
import type { RhythmQuestionObject } from './rhythmQuestionProcessor';
import RhythmQuestionProcessor from './rhythmQuestionProcessor';

export default class Question extends RhythmQuestionProcessor {
  static manual: boolean;

  skills: string[];

  fixedNotesCount: number;

  constructor(
    rhythmOrMusicStringOrObject: string | RhythmQuestionObject,
    questionNumber: number,
    manual = false
  ) {
    Question.manual = manual;
    super(rhythmOrMusicStringOrObject, questionNumber);

    this.fixedNotesCount = this.music.voices[0]!.measures[0]!.noteHolders.length;

    // Update the music string to the new, abridged music
    if (!Question.manual) this.rhythmOrMusicString = this.music.toString();
    if (this.timeSignature.isCompound) this.skills = ['meter_completion_compound'];
    else if (this.timeSignature.isCutTime) this.skills = ['meter_completion_cut_time'];
    else this.skills = ['meter_completion_simple'];
  }

  processQuestionString(rhythmOrMusicString: string): {
    music: Music;
    tempoRange: [number, number];
  } {
    const { music, tempoRange } = super.processQuestionString(rhythmOrMusicString);
    if (!Question.manual) {
      // console.log(`original music ${music}`);
      const toRemove = 1 + ~~(Math.random() * (music.voices[0].measures[0].noteHolders.length - 2));
      // console.log(`toRemove ${toRemove}`);
      music.voices[0].measures[0].noteHolders.splice(-toRemove);
      // console.log(`new music ${music}`);
    }

    if (music.voices[0].measures.length !== 1)
      throw new Error(`Music must have exactly one measure, not ${music.voices[0]!.measures.length}`);

    return { music, tempoRange };
  }
}
